<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-06-05 21:37:30
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-06-08 16:03:48
 * @FilePath: \lightning\src\views\warning\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="conBody">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-date-picker
          v-model="startTime"
          value-format="yyyyMMddHHmmss"
          format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="开始时间"
        ></el-date-picker>
        <el-date-picker
          style="margin-left:15px"
          v-model="endTime"
          value-format="yyyyMMddHHmmss"
          format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="结束时间"
        ></el-date-picker>
        <!-- <el-radio-group v-model="interType" style="margin-left:15px">
          <el-radio-button label="getLdJyResult">雷电实况</el-radio-button>
          <el-radio-button label="getLdJyResult2">雷电预测</el-radio-button>
        </el-radio-group>-->

        <div style="margin-left:15px">检验方式：</div>
        <el-select v-model="interType" placeholder="请选择">
          <el-option label="以雷电预测检验" value="getLdJyResult2"></el-option>
          <el-option label="以雷电实况检验" value="getLdJyResult"></el-option>
        </el-select>
        <el-button type="primary" style="margin-left:15px" @click="getData">查询</el-button>
        <el-button type="primary" @click="retuTime">重置</el-button>
        <el-button type="primary" @click="downTable">下载表格</el-button>
        <!-- <el-button type="primary" @click="changeShowType">{{isShowTable?'切换地图':'切换表格'}}</el-button> -->
      </div>

      <div>
        <div class="tableMap" id="myTableMap" v-show="!isShowTable">
          <div class="ledgonBox">
            <div class="ledgonBoxitem">
              <div class="ledgonBoxitemLeft">实况闪电:</div>
              <div class="ledgonBoxitemright">
                <img src="../../assets/litnew.png" style="width:20px;height:20px" alt srcset />
              </div>
            </div>
            <div class="ledgonBoxitem">
              <div class="ledgonBoxitemLeft">预测闪电:</div>
              <div class="ledgonBoxitemright">
                <img src="../../assets/ligthing.png" style="width:20px;height:20px" alt srcset />
              </div>
            </div>
            <div class="liColorList">
              <div class="liColorListItem">
                <div class="left" style="background-color:#d84800"></div>
                <div class="right">3公里</div>
              </div>
              <div class="liColorListItem">
                <div class="left" style="background-color:#d8b400"></div>
                <div class="right">6公里</div>
              </div>
              <div class="liColorListItem">
                <div class="left" style="background-color:#008cd8"></div>
                <div class="right">9公里</div>
              </div>
            </div>
          </div>
        </div>
        <el-table :data="tableData" style="width: 100%" height="700" v-show="isShowTable">
          <el-table-column prop="datetime" label="实况闪电时间" width="200">
            <template slot-scope="scope">
              <div>{{getTime(scope.row.datetime) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="lon" label="闪电经度"></el-table-column>
          <el-table-column prop="lat" label="闪电纬度"></el-table-column>
          <el-table-column prop="forcastLon" label="预测经度"></el-table-column>
          <el-table-column prop="forcastLat" label="预测纬度"></el-table-column>

          <el-table-column prop="dTime" label="起报时间">
            <template slot-scope="scope">
              <div>{{getTime2(scope.row.dTime) }}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="fTime" label="预测闪电时次"></el-table-column> -->
          <el-table-column prop="fTime" label="预警时效"></el-table-column>
          <el-table-column prop="sjsx" label="实际预警时效"></el-table-column>
          <el-table-column prop="hit6km" label="3公里预测结果">
            <template slot-scope="scope">
              <div>{{scope.row.hit6km==0?'未命中':'已命中'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="hit12km" label="6公里预测结果">
            <template slot-scope="scope">
              <div>{{scope.row.hit12km==0?'未命中':'已命中'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="hit18km" label="9公里预测结果">
            <template slot-scope="scope">
              <div>{{scope.row.hit18km==0?'未命中':'已命中'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="distance" sortable width="200" label="预测闪电距离(km)"></el-table-column>
          <el-table-column prop="distance" label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showAreaData(scope.row)">查看范围</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-show="isShowTable"
          style="margin-top:10px"
          background
          layout="sizes, prev, pager, next"
          :page-size="100"
          :total="listData.length"
          @current-change="pageChange"
          :current-page.sync="currentPage1"
          @size-change="sizeChange"
        ></el-pagination>
      </div>
    </el-card>
    <el-dialog
      title="范围查看"
      @opened="openPophandell"
      @closed="closeHandell"
      :visible.sync="isShoMyArea"
      width="80%"
    >
      <div class="digBox" id="newMapBox">
        <div class="ledgonBox">
          <div class="ledgonBoxitem">
            <div class="ledgonBoxitemLeft">实况闪电:</div>
            <div class="ledgonBoxitemright">
              <img src="../../assets/litnew.png" style="width:20px;height:20px" alt srcset />
            </div>
          </div>
          <div class="ledgonBoxitem">
            <div class="ledgonBoxitemLeft">预测闪电:</div>
            <div class="ledgonBoxitemright">
              <img src="../../assets/ligthing.png" style="width:20px;height:20px" alt srcset />
            </div>
          </div>
          <div class="liColorList">
            <div class="liColorListItem">
              <div class="left" style="background-color:#d84800"></div>
              <div class="right">3公里</div>
            </div>
            <div class="liColorListItem">
              <div class="left" style="background-color:#d8b400"></div>
              <div class="right">6公里</div>
            </div>
            <div class="liColorListItem">
              <div class="left" style="background-color:#008cd8"></div>
              <div class="right">9公里</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { downloadXlsx } from "../../units/index";
import { MapCreate, legendColor } from "../../map/mapImport";
import moment from "moment";
import shongjiangJson from "../../map/310117-松江区";
import shongjiangstreeJson from "../../map/310117.json";
import ligthing from "../../assets/ligthing.png";
import litnew from "../../assets/litnew.png";
export default {
  data() {
    return {
      interType: "getLdJyResult2",
      isShowWarningTable: true,
      isShoMyArea: false,
      markerLayer: null,
      streetNameLayer: null,
      streetLayer: null,
      map: null,
      isShowTable: true,
      pageSize: 100,
      currentPage1: 1,
      startTime: "20250303000000",
      endTime: "20250304000000",
      value1: "",
      value2: "",
      chooseTime: "",
      tableData: [],
      listData: [],
      chooseTableData: {},
      waringleavelList: [
        {
          num: 1,
          color: "#e6c700",
          text: "黄色"
        },
        {
          num: 2,
          color: "#e67b00",
          text: "橙色"
        },
        {
          num: 3,
          color: "#e62600",
          text: "红色"
        }
      ]
    };
  },
  created() {
    this.startTime = moment()
      .subtract(1, "d")
      .format("YYYY-MM-DD 00:00:00");
    this.endTime = moment().format("YYYY-MM-DD 00:00:00");
    this.getData();
    // this.getTime(11);
  },
  mounted() {},
  methods: {
    downTable() {
      let datalist = []; // 需要导出的表格数据
      datalist.push([
        "实况闪电时间",
        "闪电经度",
        "闪电纬度",
        "预测经度",
        "预测纬度",
        "起报时间",
        "预警时效",
        "实际预警时效",
        "3公里预测结果",
        "6公里预测结果",
        "9公里预测结果",
        "预测闪电距离"
      ]);

      // this.list 获取后台接口数据
      this.listData.forEach((item, index) => {
        // 拼接excel表格数据
        datalist.push([
          this.getTime(item.datetime),
          item.lon,
          item.lat,
          item.forcastLon,
          item.forcastLat,
          this.getTime2(item.dTime),
          item.fTime,
          item.sjsx,
          item.hit6km == 0 ? "未命中" : "已命中",
          item.hit12km == 0 ? "未命中" : "已命中",
          item.hit18km == 0 ? "未命中" : "已命中",
          item.distance
        ]);
      });
      downloadXlsx(
        datalist,
        `${this.startTime}至${this.endTime}雷电检验表.xlsx`
      );
    },
    showAreaData(data) {
      // console.log(data);
      this.chooseTableData = data;
      this.isShoMyArea = true;
    },
    closeHandell() {
      this.map.map.remove();
    },
    openPophandell() {
      this.map = new MapCreate();
      this.map.init("newMapBox");
      let t = this;
      let mymakerList2 = [];
      const style2 = {
        color: "#01203f", //线颜色
        weight: 2, //线粗细
        opacity: 1, //透明度
        fillColor: "#fff", //区域填充颜色
        fillOpacity: 0 //区域填充颜色的透明
      };
      this.streetLayer = L.geoJSON(shongjiangstreeJson.features, {
        style: style2,
        onEachFeature: function(feature, layer) {
          let print = t.getPolygon(feature.geometry.coordinates[0][0]);
          // //console.log(print);
          let myIcon = L.divIcon({
            html: `<div class="myareaNameBox" style="font-size: 12px;
    color:white;text-align:center;font-weight: 600; background-color: #01203f7e;
    ">${feature.properties.name}</div>`,
            className: "my-div-icon",
            iconSize: [80, 10]
          });
          let mymarker = L.marker(print, {
            zIndexOffset: 1000,
            icon: myIcon
          });
          mymakerList2.push(mymarker);
          // //console.log(mymarker);
        }
      }).addTo(this.map.map);
      // this.streetNameLayer = L.layerGroup(mymakerList2).addTo(this.map.map);

      const style = {
        color: "red", //线颜色
        weight: 4, //线粗细
        opacity: 1, //透明度
        fillColor: "#fff", //区域填充颜色
        fillOpacity: 0 //区域填充颜色的透明
      };
      this.areaLayer = L.geoJSON(shongjiangJson.features, {
        style: style
      }).addTo(this.map.map);
      this.map.map.fitBounds(this.areaLayer.getBounds());
      let greenIcon = L.icon({
        iconUrl: ligthing,
        iconSize: [30, 30] // size of the icon
      });
      let greenIcon2 = L.icon({
        iconUrl: litnew,
        iconSize: [30, 30] // size of the icon
      });
      let mymakerList = [];
      mymakerList.push(
        L.circle(
          [this.chooseTableData.forcastLat, this.chooseTableData.forcastLon],
          {
            radius: 3000,
            color: "#d84800",
            fillOpacity: 0
          }
        )
      );
      mymakerList.push(
        L.circle(
          [this.chooseTableData.forcastLat, this.chooseTableData.forcastLon],
          {
            radius: 6000,
            color: "#d8b400",
            fillOpacity: 0
          }
        )
      );
      mymakerList.push(
        L.circle(
          [this.chooseTableData.forcastLat, this.chooseTableData.forcastLon],
          {
            radius: 9000,
            color: "#008cd8",
            fillOpacity: 0
          }
        )
      );
      mymakerList.push(
        L.marker(
          [this.chooseTableData.forcastLat, this.chooseTableData.forcastLon],
          {
            icon: greenIcon
          }
        ).bindPopup(`
            <p>实况闪电时间：${moment(this.chooseTableData.datetime).format(
              "YYYY-MM-DD HH:mm:ss"
            )}</p>
            <p>闪电经度：${this.chooseTableData.lon}</p>
            <p>闪电纬度：${this.chooseTableData.lat}</p>
            <p>预测经度：${this.chooseTableData.forcastLon}</p>
            <p>预测纬度：${this.chooseTableData.forcastLat}</p>
            <p>起报时间：${this.chooseTableData.dTime}</p>
            <p>预警时效：${this.chooseTableData.fTime}</p>
            <p>实际预警时效：${this.chooseTableData.sjsx}</p>
            <p>3公里预测结果：${
              this.chooseTableData.hit6km == 0 ? "未命中" : "已命中"
            }</p>
            <p>6公里预测结果：${
              this.chooseTableData.hit12km == 0 ? "未命中" : "已命中"
            }</p>
            <p>9公里预测结果：${
              this.chooseTableData.hit18km == 0 ? "未命中" : "已命中"
            }</p>
            <p>预测闪电距离(km)：${this.chooseTableData.distance}</p>
            `)
      );
      mymakerList.push(
        L.marker([this.chooseTableData.lat, this.chooseTableData.lon], {
          icon: greenIcon2
        }).bindPopup(`
            <p>实况闪电时间：${moment(this.chooseTableData.datetime).format(
              "YYYY-MM-DD HH:mm:ss"
            )}</p>
            <p>经度：${this.chooseTableData.lon}</p>
            <p>纬度：${this.chooseTableData.lat}</p>
          
            `)
      );
      this.markerLayer = L.layerGroup(mymakerList)
        .addTo(this.map.map)
        .setZIndex(10);
    },
    getPolygon(pList) {
      var area = 0;
      var x = 0;
      var y = 0;
      for (var i = 1; i <= pList.length; i++) {
        var lat = pList[i % pList.length][0];
        var lng = pList[i % pList.length][1];
        var nextLat = pList[i - 1][0];
        var nextLng = pList[i - 1][1];
        var temp = (lat * nextLng - lng * nextLat) / 2;
        area += temp;
        x += (temp * (lat + nextLat)) / 3;
        y += (temp * (lng + nextLng)) / 3;
      }
      x = x / area;
      y = y / area;
      return [y, x];
    },
    changeShowType() {
      this.isShowTable = !this.isShowTable;
      if (!this.isShowTable) {
        setTimeout(() => {
          this.map = new MapCreate();
          this.map.init("myTableMap");
          this.showMakerToMap();
        }, 500);
      } else {
        this.map.map.remove();
      }
    },
    showMakerToMap() {
      if (this.markerLayer != null) {
        this.map.map.removeLayer(this.markerLayer);
        this.markerLayer = null;
      }
      if (this.streetLayer != null) {
        this.map.map.removeLayer(this.streetLayer);
        this.streetLayer = null;
      }
      if (this.streetNameLayer != null) {
        this.map.map.removeLayer(this.streetNameLayer);
        this.streetNameLayer = null;
      }
      let greenIcon = L.icon({
        iconUrl: ligthing,
        iconSize: [20, 20] // size of the icon
      });
      let greenIcon2 = L.icon({
        iconUrl: litnew,
        iconSize: [20, 20] // size of the icon
      });

      let mymakerList = [];
      this.tableData.map(item => {
        console.log(item);
        mymakerList.push(
          L.circle([item.forcastLat, item.forcastLon], {
            radius: 3000,
            color: "#d84800",
            fillOpacity: 0
          })
        );
        mymakerList.push(
          L.circle([item.forcastLat, item.forcastLon], {
            radius: 6000,
            color: "#d8b400",
            fillOpacity: 0
          })
        );
        mymakerList.push(
          L.circle([item.forcastLat, item.forcastLon], {
            radius: 9000,
            color: "#008cd8",
            fillOpacity: 0
          })
        );
        mymakerList.push(
          L.marker([item.forcastLat, item.forcastLon], {
            icon: greenIcon
          }).bindPopup(`
            <p>实况闪电时间：${moment(item.datetime).format(
              "YYYY-MM-DD HH:mm:ss"
            )}</p>
            <p>闪电经度：${item.lon}</p>
            <p>闪电纬度：${item.lat}</p>
            <p>预测经度：${item.forcastLon}</p>
            <p>预测纬度：${item.forcastLat}</p>
            <p>起报时间：${item.dTime}</p>
            <p>预警时效：${item.fTime}</p>
            <p>实际预警时效：${item.sjsx}</p>
            <p>3公里预测结果：${item.hit6km == 0 ? "未命中" : "已命中"}</p>
            <p>6公里预测结果：${item.hit12km == 0 ? "未命中" : "已命中"}</p>
            <p>9公里预测结果：${item.hit18km == 0 ? "未命中" : "已命中"}</p>
            <p>预测闪电距离(km)：${item.distance}</p>
            `)
        );
        mymakerList.push(
          L.marker([item.lat, item.lon], {
            icon: greenIcon2
          }).bindPopup(`
            <p>实况闪电时间：${moment(item.datetime).format(
              "YYYY-MM-DD HH:mm:ss"
            )}</p>
            <p>闪电经度：${item.lon}</p>
            <p>闪电纬度：${item.lat}</p>
          
            `)
        );
      });
      this.markerLayer = L.layerGroup(mymakerList).addTo(this.map.map);
      let t = this;
      let mymakerList2 = [];
      const style2 = {
        color: "#01203f", //线颜色
        weight: 2, //线粗细
        opacity: 1, //透明度
        fillColor: "#fff", //区域填充颜色
        fillOpacity: 0 //区域填充颜色的透明
      };
      this.streetLayer = L.geoJSON(shongjiangstreeJson.features, {
        style: style2,
        onEachFeature: function(feature, layer) {
          let print = t.getPolygon(feature.geometry.coordinates[0][0]);
          // //console.log(print);
          let myIcon = L.divIcon({
            html: `<div class="myareaNameBox" style="font-size: 12px;
    color:white;text-align:center;font-weight: 600; background-color: #01203f7e;
    ">${feature.properties.name}</div>`,
            className: "my-div-icon",
            iconSize: [80, 10]
          });
          let mymarker = L.marker(print, {
            zIndexOffset: 1000,
            icon: myIcon
          });
          mymakerList2.push(mymarker);
          // //console.log(mymarker);
        }
      }).addTo(this.map.map);
      this.streetNameLayer = L.layerGroup(mymakerList2).addTo(this.map.map);
      const style = {
        color: "red", //线颜色
        weight: 4, //线粗细
        opacity: 1, //透明度
        fillColor: "#fff", //区域填充颜色
        fillOpacity: 0 //区域填充颜色的透明
      };
      this.areaLayer = L.geoJSON(shongjiangJson.features, {
        style: style
      }).addTo(this.map.map);
      this.map.map.fitBounds(this.areaLayer.getBounds());
    },
    getTime(data) {
      return moment(new Date(data)).format("YYYY-MM-DD HH:mm:ss");
    },
    getTime2(data) {
      return moment(data, "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm:ss");
    },
    sizeChange(e) {
      // console.log(e);
      this.pageSize = e;
      this.tableData = this.listData.slice(
        (this.currentPage1 - 1) * this.pageSize,
        this.currentPage1 * this.pageSize
      );
    },
    pageChange() {
      // console.log(this.currentPage1);
      this.tableData = this.listData.slice(
        (this.currentPage1 - 1) * this.pageSize,
        this.currentPage1 * this.pageSize
      );
    },
    retuTime() {
      this.startTime = moment()
        .subtract(1, "d")
        .format("YYYY-MM-DD 00:00:00");
      this.endTime = moment().format("YYYY-MM-DD 00:00:00");
      this.getData();
    },
    getData() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `
${this.$url2}/inspection/${this.interType}?starttime=${this.startTime}&endtime=${this.endTime}`
      })
        .then(res => {
          console.log(res.data.data);
          // console.log();
          this.listData = res.data.data;
          this.listData.map(item => {
            if (item.hit6km == 1) {
              item.hit12km = 1;
              item.hit18km = 1;
            } else if (item.hit12km == 1) {
              item.hit18km = 1;
            }
            return item;
          });
          let selData = res.data.data.slice(
            (this.currentPage1 - 1) * this.pageSize,
            this.currentPage1 * this.pageSize
          );
              console.log(selData);
          selData.map(item => {
            if (item.hit6km == 1) {
              item.hit12km = 1;
              item.hit18km = 1;
            } else if (item.hit12km == 1) {
              item.hit18km = 1;
            }

            return item;
          });
          console.log(selData);
          
          this.tableData = selData;
          if (!this.isShowTable) {
            this.showMakerToMap();
          }
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    }
  }
};
</script>

<style>
.conBody {
  width: 100%;
  /* height: 100%; */
  min-height: calc(100vh - 84px);
  padding: 15px;
  /* background-color: red; */
}
.tableMap {
  height: 100%;
  width: 100%;
  background-color: beige;
  min-height: calc(100vh - 200px);
}
.ledgonBox {
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 999;
  width: 150px;
  /* height: 100px; */
  background-color: #011f3dcb;
  color: white;
  border: 1px solid #079dd5;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 0 5px rgba(0, 191, 255, 0.5), 0 0 10px rgba(0, 191, 255, 0.3);
}
.ledgonBoxitem {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
}
.ledgonBoxitemLeft {
  width: 50%;
  /* height: 100%; */
}
.ledgonBoxitemright {
  width: 50%;
  /* height: 100%; */
}
.liColorList {
  width: 100%;
}
.liColorListItem {
  display: flex;
  width: 100%;
  height: 30px;
  justify-content: space-between;
}
.liColorListItem .left {
  width: 50px;
  height: 20px;
}
.liColorListItem .right {
  /* width: 100px; */
  height: 30px;
}
.digBox {
  height: 500px;
  width: 100%;
  /* background-color: red; */
}
.clearfix {
  display: flex;
  align-items: center;
}
</style>